module.exports = __webpack_public_path__ + "img/bg-onboarding-third.adae7405.svg";